










































import { Component, Vue } from 'vue-property-decorator'
import { TemplateDto } from '@/models/dtos/templateDto'
import { TemplateAdminService as _templateAdminService } from '@/admin/services/templateAdmin.service'
import { PaginationDto } from '@/models/dtos/paginationDto'
import router from '@/router'
import { mixins } from 'vue-class-component'
import { TemplateMixin } from '@/mixins/templateMixin'

@Component
export default class AdminTemplateList extends mixins(TemplateMixin) {
  // Data
  private templates: TemplateDto[] | null = null

  private templatePagination: PaginationDto = { pageNumber: 1, pageSize: 15 }

  private templateItems: {
    id: string;
    type: string;
    shorthand: string;
    fullName: string;
  }[] = []

  private templateFields = [
    { key: 'type', label: 'Grupa', class: 'align-middle' },
    { key: 'shorthand', label: 'Skrót', class: 'align-middle' },
    { key: 'fullName', label: 'Pełna nazwa', class: 'align-middle' },
    { key: 'actions', label: 'Akcje', class: 'align-middle' }
  ]

  // Methods
  private async initTemplate() {
    this.templates = await _templateAdminService.getAll()

    this.templateItems = []
    for (const template of this.templates) {
      this.templateItems.push({
        id: template.id,
        type: this.templateName(template.type),
        shorthand: template.shorthand,
        fullName: template.fullName
      })
    }
  }

  private async removeTemplate(id: string) {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć ten szablon', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderCancel: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _templateAdminService.remove(id)
      this.initTemplate()
    }
  }

  private editTemplate(id: string) {
    router.push({ name: 'AdminTemplateEdit', params: { id } })
  }

  // Getters
  private get isLoaded(): boolean {
    return !this.templates
  }

  // Lifecycle
  async created() {
    this.initTemplate()
  }
}
